module.exports = __webpack_public_path__ + "static/media/handshake_series1.3cbd5924.gif";